import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Attach token from localStorage as fallback for Authorization header
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("inventur_token");
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// On 401 from any protected endpoint, clear stale auth state and bounce to login.
api.interceptors.response.use(
    (resp) => resp,
    (err) => {
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        if (status === 401 && !url.includes("/auth/login") && !url.includes("/auth/register")) {
            const wasAuthed = !!localStorage.getItem("inventur_token");
            localStorage.removeItem("inventur_token");
            localStorage.removeItem("inventur_tenant");
            // Avoid redirect loop: only redirect from non-login pages and only if we previously thought we were authed
            if (wasAuthed && !window.location.pathname.startsWith("/login")) {
                window.location.replace("/login");
            }
        }
        return Promise.reject(err);
    },
);

export function setToken(token) {
    if (token) localStorage.setItem("inventur_token", token);
    else localStorage.removeItem("inventur_token");
}

export function getToken() {
    return localStorage.getItem("inventur_token");
}
